export const ScItemTypes = {
    TOOLBUTTON :'toolbutton',
    QUESTIONELEMENT:'questionelement',
}